import React from"react";
import { Collapse } from "antd";
import { FaAffiliatetheme } from "react-icons/fa";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import IntegrationTable from "./IntegrationTable";
import { useState } from "react";
import { BiSolidDiscount } from "react-icons/bi";
export default function Integration({active,setActive}){
    // const [active, setActive] = useState("");
    const handleCollapseChange = (key) => {
    setActive((prev) => (prev === key ? "" : key));
  };

  console.log(active, 'active_KEY');
    return (
        <div className="pr-[0.3vw] pb-[0.5vw]">
            <Collapse
                activeKey={active}
                onChange={() => handleCollapseChange("12")}
                className="bg-[#1F487C] rounded-2xl border border-[#1F487C] shadow-[rgba(0,0,0,0.45)] shadow-xl "
                size="large"
                expandIcon={({ isActive }) =>
                    isActive ? (
                        <IoIosArrowUp
                            className="mt-[0.5vw]"
                            style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw"}}
                        />
                    ) : (
                        <IoIosArrowDown
                            className="mt-[1.5vw]"
                            style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
                        />
                    )
                }
                expandIconPosition="right"
                items={[
                    {
                        key: "12",
                        label: (
                            <div className="flex items-center h-[5vh]">
                                <div className="col-span-2 pt-[0.3vw]">
                                    <span className="">
                                        {/* <BiSolidDiscount
                                            style={{
                                                color: "#FFFFFF",
                                                height: "2.3vw",
                                                width: "2.3vw",
                                                rotate:"180%"
                                            }}
                                        /> */}
                                    </span>
                                </div>
                                <div className="col-span-2 pl-[1vw]">
                                    <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                                        TBS Deal
                                    </span>
                                    <p className="text-[#FFFFFF] text-[0.8vw]">
                                        Create exclusive deals with duration and discount percentages
                                    </p>
                                </div>
                            </div>
                        ),
                         children: <IntegrationTable />,
                    },
                ]}
            />
        </div>
    );
}